export const PATHS = {
  login: "/login",
  workOrderPage: "/work-orders",
  workOrderCreate: "/work-orders/new",
  admin: "/admin",
  calendar: "/kalendar",
  zeitmanagement: "/zeitmanagement",
  zeitmanagementCreate: "/zeitmanagement/new",
  zeitmanagementEdit: "/zeitmanagement/:entryId/edit",
  aufgaben: "/aufgaben",
  aufgabenCreate: "/aufgaben/new",
  aufgabenEdit: "/aufgaben/:taskId/edit",
  aufgabenPlan: "/aufgaben/plan",
  reschedule: "/reschedule",
  disposition: "/disposition",
  workOrderDetail: "/work-orders/:workOrderId",
  users: "/users",
  userCreate: "/users/new",
  userEdit: "/users/:userId/edit",
  workerCalendar: "/worker/calendar",
  workerPrivatzeit: "/worker/privatzeit",
  workerAppointment: "/worker/appointments/:appointmentId",
  workerZeitmanagementEdit: "/worker/zeitmanagement/:entryId/edit",
  workerTask: "/worker/tasks/:taskId",
  controlling: '/controlling',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  settings: '/admin/settings',
  settingsMail: '/admin/settings/mail',
  arbeitszeitReport: '/arbeitszeit-report',
} as const;